import styled from "styled-components";

export const StyledHookOptionContainer = styled.div`
    & > div {
        box-sizing: border-box;
    }
`;
